// PRICE CHANGE ON COLOR SWATCH
(function() {
  function on$Load(callback) {
    var loaded = false;
    var timer = setInterval(function() {
      if (window.jQuery) {
        loaded = true;
      }

      if (loaded) {
        clearInterval(timer);
        callback();
      }
    }, 100);
  }
  
  on$Load(function() {
    collectionHoverPrice();
  });
  
  function collectionHoverPrice() {
    $(document).on('mouseenter', '[data-variant-price]', function(e) {
      var $item = $(e.currentTarget);
      var currentPrice_html = $item.closest('.grid__item').find('.grid-product__price').html();
      $item.data('current-price', currentPrice_html);
      $item.closest('.grid__item').find('.grid-product__price').html($item.data('variant-price'));
    });

    $(document).on('mouseleave', '[data-variant-price]', function(e) {
      var $item = $(e.currentTarget);
      $item.closest('.grid__item').find('.grid-product__price').html($item.data('current-price'));
    });  
  }  
})();

// FOOTER NEWSLETTER HONEYPOT
const Form = document.querySelector('#newsletter-footer');
const Honeypot = Form.querySelector('.hp-bcontrol input');
Form.addEventListener('submit', event => {
  if(Honeypot.value && Honeypot.value !== '') {
    event.preventDefault();
    console.log('nope');
  }
});